import styled, { css } from 'styled-components';
import colors from '../../helpers/colors';
import spacing from '../../helpers/spacing';
import LazyImg from '../LazyImg';

export const ImageStyle = styled(LazyImg)`
  display: block;
  width: 100%;
  object-fit: contain;
  border-radius: ${spacing(1)};
`;

const focusStyle = css`
  ::before {
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    border: inset 2px ${colors.core02};
    border-radius: ${spacing(1)};
    content: '';
  }

  // Disable browser default focus behaviour
  outline: none;
`;

const hoverStyle = css`
  box-shadow: 0 ${spacing(0.5)} ${spacing(1)} ${colors.neutral04};
`;

export const ImageLink = styled.a`
  display: block;
  position: relative;
  border-radius: ${spacing(1)};

  &:hover {
    ${hoverStyle}
  }

  &:focus-visible {
    ${hoverStyle}
    ${focusStyle}
  }

  & ${ImageStyle} {
    transition: box-shadow 0.2s linear;
  }
`;
